/* eslint-disable react/prop-types, react/jsx-closing-bracket-location, consistent-return */
import React, { PropTypes } from 'react';
import { t } from 'es6/services/localization';
import Keys from 'es6/core/keys';
import { bindProps } from 'es6/helpers/react';
import { NavButton, Navigation } from 'es6/components/apps/navigation';
import StudyScreen from 'es6/components/apps/screens/study';

function DefaultNavigation({ disableEnterKey, disableArrowKeys, saveNavigationRef, isNew, onVeryWell, onWell, onNotWell, onDontKnow }) {
  return (
    <Navigation disableEnterKey={disableEnterKey} disableArrowKeys={disableArrowKeys} ref={saveNavigationRef}>
      <NavButton align="left" keyCode={Keys[1]} onClick={onDontKnow} className="btn-danger">
        {isNew ? t('dont-know') : t('dont-know-review')}
      </NavButton>

      <NavButton align="center" keyCode={Keys[2]} onClick={onNotWell}>
        {isNew ? t('not-well') : t('not-well-review')}
      </NavButton>
      <NavButton align="center" focused keyCode={Keys[3]} onClick={onWell}>
        {isNew ? t('well') : t('well-review')}
      </NavButton>
      <NavButton align="center" keyCode={Keys[4]} onClick={onVeryWell}>
        {isNew ? t('very-well') : t('very-well-review')}
      </NavButton>
    </Navigation>
  );
}

function RepeatNavigation({ disableEnterKey, disableArrowKeys, saveNavigationRef, onWell, onDontKnow }) {
  return (
    <Navigation disableEnterKey={disableEnterKey} disableArrowKeys={disableArrowKeys} ref={saveNavigationRef}>
      <NavButton align="center" keyCode={Keys[1]} onClick={onDontKnow}>{t('js_iknow.no')}</NavButton>
      <NavButton align="center" focused keyCode={Keys[2]} onClick={onWell}>{t('js_iknow.yes')}</NavButton>
    </Navigation>
  );
}

function SelfAssessmentStudyScreen({
  isNew,
  isRepeatQuiz,
  itemPackage,
  onDontKnow,
  onNotWell,
  onWell,
  onVeryWell,
  showTranscription,
}) {
  const navigationProps = { onDontKnow, onNotWell, onWell, onVeryWell };
  const navigation = isRepeatQuiz ? RepeatNavigation : DefaultNavigation;

  return (
    <StudyScreen
      animateOnMount={false}
      customNavigation={bindProps(navigation, navigationProps)}
      isNew={isNew}
      itemPackage={itemPackage}
      playAudioOnMount
      showTranscription={showTranscription} />
  );
}

function isDefaultValidation(props, propName) {
  if (props.isRepeatQuiz !== true && typeof props[propName] !== 'function') {
    return new Error(`${propName} is required if isRepeatQuiz isn't set`);
  }
}

SelfAssessmentStudyScreen.propTypes = {
  itemPackage: PropTypes.object.isRequired,
  isNew: PropTypes.bool,
  isRepeatQuiz: PropTypes.bool,

  // Required when it is not a repeat quiz.
  onVeryWell: isDefaultValidation,
  onNotWell: isDefaultValidation,

  onWell: PropTypes.func.isRequired,
  onDontKnow: PropTypes.func.isRequired,
  showTranscription: PropTypes.bool,
};


SelfAssessmentStudyScreen.defaultProps = {
  isNew: false,
  isRepeatQuiz: false,
  showTranscription: false,
};

export default SelfAssessmentStudyScreen;
